__turbopack_context__.v({
  "burgerButton": "Navigation-module-scss-module__NGMTAa__burgerButton",
  "logo": "Navigation-module-scss-module__NGMTAa__logo",
  "logoRow": "Navigation-module-scss-module__NGMTAa__logoRow",
  "nav": "Navigation-module-scss-module__NGMTAa__nav",
});
